import { useMemo } from 'react';

import blackHistory from '#src/assets/wordmark/blackHistory.svg';
import pride from '#src/assets/wordmark/pride.svg';

import { useSessionConfiguration } from '#src/app/shared/hooks/sessionConfiguration';

type Result = ModelHookResult<{
	logoUrl: string | undefined;
}>;

export function useLogo(): Result {
	const { featureConfigs } = useSessionConfiguration();

	return {
		data: {
			logoUrl: useMemo(() => {
				if (featureConfigs.showBlackHistoryLogo) return blackHistory;
				if (featureConfigs.showPrideLogo) return pride;
				return undefined;
			}, [featureConfigs]),
		},
	};
}
